export default {
    "html": require('./html').default,
    "scss": require('./scss').default,
    "css": require('./css').default
}